import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const toSlug = (str) =>
  str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');


const COMPOSER_COLUMNS_1 = [
  {
    title: 'Tailles',
    items: [
      { label: 'Simple', price: '7.50 €' },
      { label: 'Double', price: '8.90 €' },
      { label: 'Maxi', price: '11.90 €' },
    ],
  },
  {
    title: 'Viandes',
    items: [
      { label: 'Cordon bleu' },
      { label: 'Kebab' },
      { label: 'Bœuf haché' },
      { label: 'Tenders' },
      { label: 'Filet de poulet' },
    ],
  },
  {
    title: 'Sauces',
    split: true,
    items: [
      { label: 'Algérienne', piments: 1 },
      { label: 'Barbecue' },
      { label: 'Biggy burger' },
      { label: 'Curry' },
      { label: 'Moutarde miel' },
      { label: 'Samouraï', piments: 1 },
      { label: 'Harissa', piments: 2 },
      { label: 'Ketchup' },
      { label: 'Mayo classique' },
      { label: 'Mayo aux herbes' },
    ],
  },
  {
    title: 'Charcuteries',
    items: [
      { label: 'Bacon de volaille', price: '+0.90 €' },
      { label: 'Lardons de dinde', price: '+0.90 €' },
    ],
  },
];

const COMPOSER_COLUMNS_2 = [
  {
    title: 'Végétarien',
    items: [
      { label: 'Crudités', price: '+0.90 €' },
      { label: 'Oignons rouges', price: '+0.50 €' },
      { label: 'Oignons frits', price: '+0.90 €' },
      { label: 'Cornichons', price: '+0.50 €' },
      { label: 'Rösti', price: '+1.50 €' },
      { label: 'Miel', price: '+0.90 €' },
    ],
  },
  {
    title: 'Fromages',
    items: [
      { label: 'Bleu', price: '+1.50 €' },
      { label: 'Comté', price: '+1.90 €' },
      { label: 'Cheddar', price: '+0.90 €' },
      { label: 'Raclette', price: '+1 €' },
      { label: 'Reblochon', price: '+1.50 €' },
      { label: 'Chèvre', price: '+1.50 €' },
      { label: 'Tomme', price: '+1.50 €' },
    ],
  },
  {
    title: 'Gratinez',
    image: '/gratiner.png',
    items: [
      { label: 'Fromage', price: '+2 €' },
      { label: 'Fromage + charcuterie', price: '+3 €' },
      { label: '4 fromages', price: '+3 €' },
    ],
  },
  {
    title: 'Bowls',
    bowl: true,
    items: [
      { label: 'Change ton tacos en bowl', price: '+1 €' },
    ],
  },
];

function ComposerTable({ columns, offset = 0 }) {
  return (
    <div className="lacarte-composer-grid">
      {columns.map((col, i) => (
        <div key={col.title} className="lacarte-composer-col">
          <h3 className="lacarte-composer-h3">
            {offset + i + 1} : {col.title.normalize('NFD').replace(/[\u0300-\u036f]/g, '')}
          </h3>
          {col.image && (
            <img src={col.image} alt={col.title} style={{ width: '60%', maxHeight: '60px', objectFit: 'contain', marginBottom: '8px' }} />
          )}
          {col.bowl ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <p style={{ fontFamily: 'Rough Motion, sans-serif', fontSize: '22px', color: '#000', textTransform: 'uppercase', margin: 0, lineHeight: 1.2 }}>
                Change ton tacos en bowls
              </p>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', flexWrap: 'wrap' }}>
                <img src="/bowl.png" alt="Bowl" style={{ width: '100%', maxWidth: '120px', objectFit: 'contain', flexShrink: 0 }} />
                <span style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#000' }}>+ 1 €</span>
              </div>
            </div>
          ) : col.split ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 12px' }}>
              <div>
                {col.items.slice(0, Math.ceil(col.items.length / 2)).map((item) => (
                  <p key={item.label} style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#000', textTransform: 'uppercase', margin: '0 0 6px 0', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {item.label}
                    {item.piments && (
                      <span style={{ display: 'flex', gap: '1px' }}>
                        {Array.from({ length: item.piments }).map((_, j) => (
                          <img key={j} src="/piment.png" alt="piment" style={{ height: '14px', objectFit: 'contain' }} />
                        ))}
                      </span>
                    )}
                  </p>
                ))}
              </div>
              <div>
                {col.items.slice(Math.ceil(col.items.length / 2)).map((item) => (
                  <p key={item.label} style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#000', textTransform: 'uppercase', margin: '0 0 6px 0', display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {item.label}
                    {item.piments && (
                      <span style={{ display: 'flex', gap: '1px' }}>
                        {Array.from({ length: item.piments }).map((_, j) => (
                          <img key={j} src="/piment.png" alt="piment" style={{ height: '14px', objectFit: 'contain' }} />
                        ))}
                      </span>
                    )}
                  </p>
                ))}
              </div>
            </div>
          ) : (
            col.items.map((item) => (
              <p key={item.label} style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', color: '#000', textTransform: 'uppercase', margin: '0 0 6px 0' }}>
                {item.label}{item.price ? ` : ${item.price}` : ''}
              </p>
            ))
          )}
        </div>
      ))}
    </div>
  );
}

const CATEGORIES = [
  {
    label: 'Choix du menu',
    products: [
      { name: 'Menu S', price: '+1.50 €', image: '/menus.png', imageSize: '90%' },
      { name: 'Menu M', price: '+3.50 €', image: '/menum.png', imageSize: '90%' },
      { name: 'Menu L', price: '+4 €', image: '/menul.png', imageSize: '90%' },
      { name: 'Menu XL', price: '+4.90 €', image: '/menuxl.png', imageSize: '90%' },
    ],
  },
  {
    label: 'Nos Smash Burgers',
    products: [
      { name: 'Smash Original', price: '7.90 €', image: '/original.png' },
      { name: 'Smash Deluxe', price: '11.90 €', image: '/deluxe.png' },
      { name: 'Smash Chicken Tower', price: '8.50 €', image: '/chickentower.png' },
      { name: 'Smash Double Comté', price: '12.50 €', image: '/comte.png' },
      { name: 'Smash Smoky', price: '11.90 €', image: '/smoky.png' },
      { name: 'Smash Blue Pepper', price: '9.50 €', image: '/blue.png' },
      { name: 'Smash Chèvre Miel', price: '9.50 €', image: '/chevremiel.png' },
      { name: 'Smash Double Raclette', price: '11.90 €', image: '/doubleraclette.png' },
    ],
  },
  {
    label: 'Crousty',
    products: [
      { name: "L'Original Crousty", price: '10 €', image: '/crousty.png', imageSize: '90%' },
    ],
  },
  {
    label: 'Nos Tacos',
    products: [
      { name: 'Tacos Tartiflette', price: '6.50 €', image: '/tartiflette.png', imageSize: '90%' },
      { name: 'Tacos Raclette', price: '8.90 €', image: '/raclette.png', imageSize: '90%' },
      { name: 'Tacos New-Yorkais', price: '8.50 €', image: '/newyorkais.png', imageSize: '90%' },
      { name: 'Tacos 4 Fromages', price: '9.50 €', image: '/4fromages.png', imageSize: '90%' },
      { name: 'Tacos Kebab', price: '7.90 €', image: '/kebab.png', imageSize: '90%' },
      { name: 'Tacos Carnivore', price: '9.50 €', image: '/carnivore.png', imageSize: '50%' },
      { name: 'Tacos Bauju', price: '8.90 €', image: '/bauju.png', imageSize: '90%' },
      { name: 'Tacos Veggie', price: '6.50 €', image: '/veggie.png', imageSize: '90%' },
    ],
  },
  {
    label: 'Tacos à Composer',
    products: [
      { name: 'Tacos Simple', price: '7.50 €' },
      { name: 'Tacos Double', price: '8.90 €' },
      { name: 'Tacos Maxi', price: '11.90 €' },
    ],
  },
  {
    label: 'Extras',
    products: [
      { name: 'Wrap Chicken', price: '6.80 €', image: '/wrapckicken.png' },
      { name: 'Wrap Chèvre', price: '6.50 €', image: '/wrapchevre.png' },
      { name: 'Salade Classic Caesar', price: '8.90 €', image: '/caesar.png' },
      { name: 'Salade Chèvre Chaud', price: '8.90 €', image: '/saladechevre.png' },
      { name: 'Baguette Chicken & Mozza', price: '7.50 €', image: '/chickenmozza.png' },
      { name: 'Baguette Chicken & Beef', price: '8.50 €', image: '/chickenbeef.png' },
    ],
  },
  {
    label: 'Frieds',
    products: [
      { name: 'Chicken Nuggets', price: '3.90 € - 7.90 €', image: '/nuggets.png' },
      { name: 'Tenders', price: '3.50 € - 6.90 €', image: '/tenders.png' },
      { name: 'Frites', price: '2.90 €', image: '/frite.png' },
      { name: 'Frite Fromagère', price: '3.90 €', image: '/fritefromage.png' },
      { name: 'Frite Crispy Bacon', price: '4.90 €', image: '/fritebacon.png' },
      { name: 'Tartifrites', price: '5.50 €', image: '/fritebacon.png' },
      { name: 'Mac & Cheese Balls', price: '3.70 € - 5.50 €', image: '/maccheese.png' },
      { name: 'Chili Cheese Nuggets', price: '3.70 € - 5.50 €', image: '/chilicheese.png', imageSize: '100%' },
      { name: 'Crousty Chèvre', price: '3.50 € - 4.90 €', image: '/croustychevre.png' },
    ],
  },
  {
    label: 'Boissons',
    products: [
      { name: 'Coca-Cola', price: '2 €', image: '/coca.png' },
      { name: 'Coca-Cola Zero', price: '2 €', image: '/zero.png' },
      { name: 'Coca-Cola Cherry', price: '2 €', image: '/cherry.png', imageSize: '55%' },
      { name: 'Perrier', price: '2 €', image: '/perrier.png' },
      { name: 'Eau', price: '2 €', image: '/eau.png' },
      { name: 'Ice Tea', price: '2 €', image: '/icetea.png' },
      { name: 'Oasis Tropical', price: '2 €', image: '/oasis.png' },
      { name: '7UP Mojito', price: '2 €', image: '/7up.png' },
      { name: 'Fanta Orange', price: '2 €', image: '/fanta.png' },
      { name: 'Sprite', price: '2 €', image: '/sprite.png' },
    ],
  },
  {
    label: 'Desserts',
    products: [
      { name: 'Tiramisu Nutella', price: '3.90 €', image: '/nutella.png' },
      { name: 'Tiramisu Oreo', price: '3.90 €', image: '/oreo.png' },
      { name: 'Tiramisu Kinder Bueno White', price: '3.90 €', image: '/kinder.png' },
    ],
  },
];

export default function LaCarte() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);
  const observerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    document.title = 'La Carte — Four A Tacos';
  }, []);

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sectionRefs.current.indexOf(entry.target);
            if (index !== -1) setActiveIndex(index);
          }
        });
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0 }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observerRef.current.observe(ref);
    });

    return () => observerRef.current.disconnect();
  }, []);

  const scrollToSection = (index) => {
    const el = sectionRefs.current[index];
    if (!el) return;
    const mobileCats = document.querySelector('.lacarte-mobile-cats');
    const offset = 80 + (mobileCats ? mobileCats.offsetHeight : 0) + 16;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  return (
    <div style={{ backgroundColor: '#fff', minHeight: '100vh' }}>
      <Header />

      <div className="lacarte-wrapper">

        {/* Sidebar desktop */}
        <aside className="lacarte-sidebar">
          <nav>
            {CATEGORIES.map((cat, i) => (
              <button
                key={cat.label}
                onClick={() => scrollToSection(i)}
                style={{
                  display: 'block',
                  width: '100%',
                  textAlign: 'left',
                  padding: '12px 32px',
                  fontFamily: 'Jane Light, sans-serif',
                  fontSize: '15px',
                  fontWeight: i === activeIndex ? '700' : '400',
                  color: i === activeIndex ? '#C10230' : '#000',
                  background: 'none',
                  border: 'none',
                  borderLeft: i === activeIndex ? '3px solid #C10230' : '3px solid transparent',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  boxSizing: 'border-box',
                }}
              >
                {cat.label}
              </button>
            ))}
          </nav>
        </aside>

        {/* Tabs mobile */}
        <div className="lacarte-mobile-cats">
          {CATEGORIES.map((cat, i) => (
            <button
              key={cat.label}
              onClick={() => scrollToSection(i)}
              style={{ flexShrink: 0, fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: i === activeIndex ? '700' : '500', color: i === activeIndex ? '#fff' : '#4A4A4A', backgroundColor: i === activeIndex ? '#C10230' : '#f0f0f0', border: 'none', borderRadius: '20px', padding: '7px 16px', cursor: 'pointer', whiteSpace: 'nowrap' }}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Contenu */}
        <main className="lacarte-main">
          {CATEGORIES.map((cat, i) => (
            <section
              key={cat.label}
              id={toSlug(cat.label)}
              ref={(el) => (sectionRefs.current[i] = el)}
              style={{ marginBottom: '72px' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                <h2 className="lacarte-section-title">
                  {cat.label}
                </h2>
                {cat.label === 'Nos Tacos' && (
                  <img src="/maxi.png" alt="Maxi" className="lacarte-section-logo" />
                )}
                {cat.label === 'Nos Smash Burgers' && (
                  <img src="/sasmash.png" alt="Sa Smash" className="lacarte-section-logo" />
                )}
              </div>

              {cat.label === 'Tacos à Composer' ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
                  <ComposerTable columns={COMPOSER_COLUMNS_1} offset={0} />
                  <ComposerTable columns={COMPOSER_COLUMNS_2} offset={4} />
                </div>
              ) : (
                <div className="lacarte-product-grid">
                  {cat.products.map((product) => (
                    <Link key={product.name} to={`/produit/${toSlug(product.name)}?categorie=${toSlug(cat.label)}`} style={{ textDecoration: 'none' }}>
                      <div
                        className="lacarte-product-card"
                        style={{ backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', transition: 'transform 0.2s, box-shadow 0.2s' }}
                        onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)'; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)'; }}
                      >
                        {product.image
                          ? <div className="lacarte-product-img" style={{ backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><img src={product.image} alt={product.name} style={{ width: product.imageSize || '65%', height: product.imageSize || '65%', objectFit: 'contain' }} /></div>
                          : <div className="lacarte-product-img" style={{ backgroundColor: '#e0e0e0' }} />
                        }
                        <div style={{ padding: '16px' }}>
                          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '19px', fontWeight: '600', color: '#000', margin: '0 0 6px 0' }}>
                            <span style={{ fontFamily: 'Rough Motion, sans-serif', textTransform: 'uppercase' }}>{product.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')}</span>
                          </p>
                          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', fontWeight: '700', color: '#C10230', margin: 0 }}>
                            {product.price}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </section>
          ))}
        </main>

      </div>

      {/* Allergènes */}
      <div id="allergenes" className="lacarte-allergenes" style={{ backgroundColor: '#fff', borderTop: '1px solid #e5e5e5', boxSizing: 'border-box' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '13px', fontWeight: '700', color: '#C10230', textTransform: 'uppercase', letterSpacing: '1.5px', margin: '0 0 12px 0' }}>
            Allergènes
          </h2>
          <p style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '14px', color: '#4A4A4A', lineHeight: '1.8', margin: '0 0 20px 0' }}>
            Pour toute information sur les allergènes présents dans nos produits, contactez-nous au{' '}
            <a href="tel:0422910537" style={{ color: '#C10230', fontWeight: '600', textDecoration: 'none' }}>04 22 91 05 37</a>{' '}
            ou demandez à notre équipe sur place.
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {[
              'Gluten', 'Crustacés', 'Œufs', 'Poissons', 'Arachides',
              'Soja', 'Lait', 'Fruits à coque', 'Céleri', 'Moutarde',
              'Graines de sésame', 'Dioxyde de soufre et sulfites', 'Lupin', 'Mollusques',
            ].map((a) => (
              <span key={a} style={{ fontFamily: 'Jane Light, sans-serif', fontSize: '12px', fontWeight: '500', color: '#4A4A4A', backgroundColor: '#fff', border: '1px solid #e5e5e5', borderRadius: '20px', padding: '5px 14px' }}>
                {a}
              </span>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
